import type { ObjectView } from '../model/table';

/** Presentation-neutral, public catalog annotations with plain readable labels. */
export function CatalogMetadata({ object }: { object: ObjectView }) {
  const fields = object.catalog?.fields;
  if (!fields || object.faceDown) return null;
  const rows = ['type', 'category', 'rarity'].flatMap(key => {
    const label = fields[`${key}Label`], help = fields[`${key}Help`];
    return typeof label === 'string' ? [{ key, label, help: typeof help === 'string' ? help : '' }] : [];
  });
  return rows.length ? <dl className="catalog-metadata" aria-label="Card types and keywords">
    {rows.map(row => <div key={row.key}><dt>{row.label}</dt><dd>{row.help}</dd></div>)}
    {object.tags.length > 0 && <div><dt>Keywords</dt><dd>{object.tags.map(tag => tag.replaceAll('-', ' ')).join(' · ')}</dd></div>}
  </dl> : null;
}
